import gql from 'graphql-tag'

export const getTasks = gql`
  query($paging: PagingQuery, $order: TasksOrder, $filter: TasksFilter!) {
    getTasks(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      tasks {
        id
        title
        status
        dueDate
        reminderDate
        priority
        assignedTo {
          id
          username
        }
        createdAt
        notes
        createdBy {
          id
          username
        }
        policies {
          id
          policyName
        }
        accounts {
          id
          name
        }
        cases {
          id
          inquiryName
        }
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const newTask = gql`
  mutation($input: TaskInput!) {
    newTask(
      input: $input
    ) {
      id
    }
  }
`

export const editTask = gql`
  mutation($input: TaskInput!, $taskId: Int!) {
    editTask(
      input: $input,
      taskId: $taskId
    ) {
      id
    }
  }
`

export const deleteTask = gql`
  mutation($taskId: Int!) {
    deleteTask(
      taskId: $taskId
    )
  }
`

export const getTask = gql`
  query($taskId: Int!) {
    getTask(
      taskId: $taskId
    ) {
      id
      title
      status
      dueDate
      reminderDate
      priority
      assignedTo {
        id
        username
      }
      createdAt
      updatedAt
      notes
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
      comments {
        content
        creator
        createdAt
      }
      policies {
        id
        policyName
      }
      accounts {
        id
        name
      }
      cases {
        id
        inquiryName
      }
    }
  }
`

export const commentToTask = gql`
  mutation($taskId: Int!, $content: String!) {
    commentToTask(
      taskId: $taskId,
      content: $content
    ) {
      id
    }
  }
`

export const completeTask = gql`
  mutation($taskId: Int!) {
    completeTask(
      taskId: $taskId
    )
  }
`
